'use strict';

var React = require('react');

var SvgSandboxMajor = function SvgSandboxMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.605 3.362a.75.75 0 0 1 .79 0l5.25 3.25a.75.75 0 0 1 .345.763c.006.04.01.082.01.125v5.5a.75.75 0 0 1-.355.638l-5.25 3.25a.75.75 0 0 1-.79 0l-5.25-3.25a.75.75 0 0 1-.355-.638v-5.5c0-.043.004-.085.01-.125a.75.75 0 0 1 .345-.763l5.25-3.25Zm1.145 7.556 3.75-2.322v3.986l-3.75 2.322v-3.986Zm-1.5 0-3.75-2.322v3.986l3.75 2.322v-3.986Zm-3.075-3.668 3.825 2.368 3.825-2.368-3.825-2.368-3.825 2.368Z"
  }));
};
SvgSandboxMajor.displayName = "SandboxMajor";

exports.SvgSandboxMajor = SvgSandboxMajor;
